import React, { useState } from 'react';
import Logo from '../../assets/miporis.jpg';

function Navbar() {
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

    return (
        <header className="sticky top-0 z-50 w-full bg-white/95 backdrop-blur-md border-b border-gray-100">
            <div className="max-w-[1200px] mx-auto px-6 h-20 flex items-center justify-between">
                <div className="flex items-center gap-3">
                    <a href='/' className="flex items-center cursor-pointer transition-opacity hover:opacity-80">
                        <img src={Logo} className="h-8" alt="MIPORIS Logo" />
                    </a>
                </div>
                
                <nav className="hidden md:flex items-center gap-8">
                    <a className="text-sm font-semibold text-[#1B1B1B] hover:text-[#0077C8] transition-colors" href="#problem">Risk Assessment</a>
                    <a className="text-sm font-semibold text-[#1B1B1B] hover:text-[#0077C8] transition-colors" href="#context">Provision 29</a>
                    <a className="text-sm font-semibold text-[#1B1B1B] hover:text-[#0077C8] transition-colors" href="#solution">Solution</a>
                    <button 
                        className="bg-[#0077C8] text-white px-5 py-2.5 rounded-lg text-sm font-bold tracking-wide hover:brightness-110 transition-all shadow-md"
                        onClick={() => {
                            window.location.href = "mailto:john@dagalagroup.com?subject=Provision 29 Readiness Call";
                        }}
                    >
                        Book a Provision 29 Readiness Call
                    </button>
                </nav>

                {/* Mobile menu toggle */}
                <button
                    onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                    type="button"
                    className="md:hidden inline-flex items-center p-2 w-10 h-10 justify-center text-gray-600 rounded-lg hover:bg-gray-100"
                >
                    <span className="sr-only">Open main menu</span>
                    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
                    </svg>
                </button>
            </div>

            {/* Mobile Menu */}
            {isMobileMenuOpen && (
                <div className="md:hidden border-t border-gray-100 bg-white">
                    <div className="px-6 py-4 space-y-3">
                        <a href="#problem" className="block text-sm font-semibold text-[#1B1B1B] hover:text-[#0077C8] transition-colors" onClick={() => setIsMobileMenuOpen(false)}>Risk Assessment</a>
                        <a href="#context" className="block text-sm font-semibold text-[#1B1B1B] hover:text-[#0077C8] transition-colors" onClick={() => setIsMobileMenuOpen(false)}>Provision 29</a>
                        <a href="#solution" className="block text-sm font-semibold text-[#1B1B1B] hover:text-[#0077C8] transition-colors" onClick={() => setIsMobileMenuOpen(false)}>Solution</a>
                        <button 
                            className="w-full bg-[#0077C8] text-white px-5 py-2.5 rounded-lg text-sm font-bold tracking-wide hover:brightness-110 transition-all shadow-md mt-4"
                            onClick={() => {
                                window.location.href = "mailto:john@dagalagroup.com?subject=Provision 29 Readiness Call";
                            }}
                        >
                            Book a Provision 29 Readiness Call
                        </button>
                    </div>
                </div>
            )}
        </header>
    );
}

export default Navbar;
